<app-wg-navbar></app-wg-navbar><app-wg-sidebar></app-wg-sidebar>
<div class="working-content" [class.sidebar-visible]="sidebar.visible()">
  <main><router-outlet /></main>
  <app-wg-footer></app-wg-footer>
</div>
